import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const AdOnlyFloatingConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Ad Only Floating"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Ad Only Floating']}
				description="Manage Ad Only Floating Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container style={{ marginTop: '4rem', marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default AdOnlyFloatingConfig;
